import { render, staticRenderFns } from "./IeManagement.vue?vue&type=template&id=2636aac1&scoped=true"
import script from "./IeManagement.vue?vue&type=script&lang=js"
export * from "./IeManagement.vue?vue&type=script&lang=js"
import style0 from "./IeManagement.vue?vue&type=style&index=0&id=2636aac1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636aac1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2636aac1')) {
      api.createRecord('2636aac1', component.options)
    } else {
      api.reload('2636aac1', component.options)
    }
    module.hot.accept("./IeManagement.vue?vue&type=template&id=2636aac1&scoped=true", function () {
      api.rerender('2636aac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/IeManagement.vue"
export default component.exports